import * as S from './MenuIcon.style';

export { default as MenuIcon } from './MenuIcon';
export * from './MenuIcon.types';
export { S };
